/**
 * File: footer.js
 * Origin: isotect
 * Description: [TODO: Description]
 *
 * Version: v1.1.2
 * Created: 2026-02-16
 * Last Updated: 2026-06-22
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

// Local project files
import { routes } from "../../constants/routes";

// Footer
export const footer = {
    description:
        "ISOTECT™ empowers engineering teams with innovative technology and expertise to redefine how projects are designed, built, and delivered.",
    links: {
        linkedInLink: "https://www.linkedin.com/company/isotect-inc/",
    },
    navigation: {
        company: [
            { label: "COMPANY", link: routes.public.home.root },
            { label: "About", link: routes.public.home.root },
            { label: "Careers", link: routes.public.home.root },
        ],
        products: [
            { label: "PRODUCTS", link: routes.public.products.root },
            { label: "Tecthub", link: routes.public.products.root },
            { label: "Flowkit", link: routes.public.products.root },
            { label: "Nameplate", link: routes.public.products.root },
            { label: "Isocheck", link: routes.public.products.root },
        ],
        services: [
            { label: "SERVICES", link: routes.public.services.root },
            { label: "Surveying", link: routes.public.services.surveying.abs },
            { label: "Drafting", link: routes.public.services.drafting.abs },
            { label: "Engineering", link: routes.public.services.engineering.abs },
            { label: "QA/QC Review", link: routes.public.services.qaqc.abs },
        ],
    },
    legal: {
        copyright: "© 2026 ISOTECT, INC.",
        reserved: "All RIGHTS RESERVED.",
        policies: [
            { label: "TERMS", link: routes.public.terms },
            { label: "PRIVACY", link: routes.public.privacy },
        ],
    },
};
